import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const KycAuthorizedSlice = createApi({
  reducerPath: "KycAuthorizedApi",
  baseQuery,
  tagTypes: ["KycAuthorized"],

  endpoints: (builder) => ({
    getKycAuthorizedSignatory: builder.query({
      query: ({ id }) => `/customers/kyc/signatory/${id}`,
      transformResponse: (response) => {
        console.log(response, "response check");
        return response?.data?.authorizedSignatories.map((item,index)=>{
          return {
            ...item,
            id : item.signatoryId
          }
        }) ?? [];
      },
      providesTags: ["KycAuthorized"],
    }),

    createKycAuthorizedSignatory: builder.mutation({
      query: ({ id, ...data }) => {
        // If data is object with numeric keys -> convert to array

        return {
          url: `/customers/kyc/signatory/${id}`,
          method: "PUT",
          headers: {
            "X-Request-Id": Math.random().toString(36).substring(2),
          },
          body: { signatories : data },
        };
      },
      invalidatesTags: ["KycAuthorized"],
    }),

     deleteKycAuthorizedSignatory: builder.mutation({
      query: ({ id ,subId}) => ({
        url: `/customers/kyc/signatory/${id}/${subId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["KycAuthorized"],
    }),
  }),
});

export const {
  useLazyGetKycAuthorizedSignatoryQuery,
  useCreateKycAuthorizedSignatoryMutation,
  useDeleteKycAuthorizedSignatoryMutation
} = KycAuthorizedSlice;
